module.exports = __webpack_public_path__ + "files/197f710dd030aacbf1d1ae91b05c3347.svg";